<template>
  <div class="home-wrap">
    <div class="main-wrap">
      <img class="logo-img" src="@/assets/img/h5/complete_logo.png"/>
      <div class="pay-money">
        <div class="money-div" v-show="pay_money"><span>-{{pay_money}}</span></div>
        <div class="pay-status">交易成功</div>
      </div>
      <div class="pay-detail">
        <div class="pay-info">
          <div class="pay-title">商品名称</div>
          <div class="pay-value" v-show="goods_name">{{ goods_name }}</div>
        </div>
        <div class="pay-info">
          <div class="pay-title">实付金额</div>
          <div class="pay-value" v-show="pay_money">￥<span>{{pay_money}}</span></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { isAccountRecharge } from '@/api/pay'
import pay from '@/javaApi/pay'
const payModel = new pay()
export default {
  name: "Pay",
  data() {
    return {
      pay_money: '',
      goods_name : ''
    }
  },
  created() {
    this.init();
  },
  methods: {
    // 获取界面数据
    init(){
      //获取参数
      var sub_mch_id = this.getQueryString("sub_mch_id"); //特约商户号
      console.log("sub_mch_id is " + sub_mch_id)
      var out_trade_no = this.getQueryString("out_trade_no"); //商户订单号
      console.log("out_trade_no is " + out_trade_no)
      var check_code = this.getQueryString("check_code"); //md5 校验码
      console.log("check_code is " + check_code)

      out_trade_no = '20210707105651194';
      this.getAccountMoney(out_trade_no);
    },
    // 获取账户充值
    getAccountMoney(out_trade_no){
      var param = {out_trade_no: out_trade_no};
      isAccountRecharge(param).then((response)=>{
        if(response.code == 200 && response.data.is_find) {
          this.pay_money = parseFloat(response.data.money).toFixed(2);
          this.goods_name = '账户充值';
        } else {
          this.getPackageMoney(out_trade_no);
        }
      }).catch(error=>{
        console.log(error)
      })
    },
    getPackageMoney(out_trade_no) {
      var param = {outTradeNo: out_trade_no};
      console.log(param)
      payModel.getPayStatusByH5(param).then((response)=>{
        console.log(response)
      }).catch(error=>{
        console.log(error)
      })
    },
    //获取返回页面参数
    getQueryString(name) {
      var query = window.location.search.substring(1);
      var vars = query.split("&");
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == name) {
          return pair[1];
        }
      }
      return null;
    }
  }
}
</script>

<style lang="less" scoped>
  .home-wrap{
    background: #F5F5F5;
  }
  .main-wrap{
    font-family: PingFangSC-Regular;
    margin: 53px 12px 0;
    background: #FFFFFF;
    border-radius: 8px;
    position: relative;
    .logo-img{
      width: 70px;
      position: absolute;
      top: -35px;
      left: 50%;
      transform: translateX(-50%);
      -ms-transform: translateX(-50%);	/* IE 9 */
      -moz-transform: translateX(-50%);	/* Firefox */
      -webkit-transform: translateX(-50%);/* Safari 和 Chrome */
      -o-transform: translateX(-50%); 	/* Opera */
    }
    .pay-money{
      padding-top: 58px;
      .money-div{
        font-size: 32px;
        color: #343434;
        letter-spacing: 0;
        text-align: center;
      }
      .pay-status{
        margin-top: 6px;
        font-size: 14px;
        color: #343434;
        letter-spacing: 0;
        text-align: center;
      }
    }
    .pay-detail{
      padding: 30px 16px 25px;
      .pay-info{
        display: flex;
        justify-content: space-between;
        padding: 10px 0;
        font-size: 14px;
        letter-spacing: 0;
        .pay-title{
          color: #888888;
        }
        .pay-value{
          color: #343434;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/h5/pay/Index.vue